// Common
export enum Units {
  Metric,
  Imperial,
}

// Images
export enum ImageType {
  Rgb,
  Ir,
  Sonar,
}
export enum ImageDepth {
  Three,
  Two,
  Ortho,
  Handheld,
}

// Users
export enum UserRole {
  Trial,
  Viewer,
  Uploader,
  Member,
  Manager,
  Admin,
}
export enum UserStatus {
  Deactivated,
  Activated,
  Pending,
  Deleted,
}

// Downloads
export enum DownloadStatus {
  Created = 0,
  Queued = 1,
  Processing = 3,
  Ready = 4,
}

// Capture data
export enum CaptureGeotagged {
  Unselected,
  Yes,
  No,
  Partial,
}
export enum CaptureThermalType {
  Unselected,
  Radiometric,
  NonRadiometric,
}

// Server side enums
export enum DbUserRole {
  Admin = 1,
  Manager = 2,
  Member = 3,
  Trial = 4,
  Uploader = 5,
  Viewer = 6,
}

export enum ArtifactType {
  Image = 1,
  Video,
  Blob,
  Pdf,
}
